import { render, staticRenderFns } from "./AllContinuousFilingSubmissions.vue?vue&type=template&id=c1555222&scoped=true&"
import script from "./AllContinuousFilingSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllContinuousFilingSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllContinuousFilingSubmissions.vue?vue&type=style&index=0&id=c1555222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1555222",
  null
  
)

export default component.exports